__turbopack_context__.v({
  "filled": "sFJr5G_filled",
  "heartIcon": "sFJr5G_heartIcon",
  "iconButton": "sFJr5G_iconButton",
  "inWatchlist": "sFJr5G_inWatchlist",
  "outlined": "sFJr5G_outlined",
});
